import { PageContainer } from '@amelio/ui-library';

import type { TranslationKey } from '@/i18n-key';
import type { FeatureFlagKey } from '@/utils/featureFlags';

import { EmptyState } from '@/components/EmptyState/EmptyState';
import { FeatureFlagCallout } from '@/components/FeatureFlagCallout/FeatureFlagCallout';
import { useAmelioTranslations } from '@/hooks';

interface FeatureDisabledStateProps {
    /** The flag the dev-only callout names. */
    flag: FeatureFlagKey;
    titleKey: TranslationKey;
    messageKey: TranslationKey;
}

/**
 * What a route shows while its feature flag is off: the dev-only callout (empty in production, see
 * `FeatureFlagCallout`) above a translated empty state — never the callout alone, which would leave
 * production visitors staring at a blank page.
 */
export const FeatureDisabledState = ({ flag, titleKey, messageKey }: FeatureDisabledStateProps) => {
    const { t } = useAmelioTranslations();

    return (
        <PageContainer>
            <FeatureFlagCallout featureFlag={flag} />

            <EmptyState
                title={t(titleKey)}
                message={t(messageKey)}
            />
        </PageContainer>
    );
};
